export default "__VITE_ASSET__CnBrDTMn__"